import { css } from '@emotion/react';

import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const sectionGridTemplateBase = css`
  --section-padding: 40px;
  --title-line-height: 76px;

  grid-template-columns: 1fr 510px;

  ${getMediaqueryStyled('xl')} {
    --title-line-height: 57px;

    grid-template-columns: 1fr 410px;
  }

  ${getMediaqueryStyled('lg')} {
    --section-padding: 25px;
    --title-line-height: 38px;

    grid-template-columns: 1fr 265px;
  }

  ${getMediaqueryStyled('md')} {
    --section-padding: 44px;

    grid-template-columns: 1fr;
    justify-content: stretch;
  }

  ${getMediaqueryStyled('sm')} {
    --section-padding: 38px;
  }
`;
